module.exports = __webpack_public_path__ + "img/needle-center.3a75b598.png";